module.exports = __webpack_public_path__ + "static/samplevideo-82d9b86b01560ce17d310f3fd2a79ca9.mp4";